
const constants = {
    AUTHENTICATION_ACCESS_TOKEN: 'AUTHENTICATION_ACCESS_TOKEN',
    AUTHENTICATION_REFRESH_TOKEN: 'AUTHENTICATION_REFRESH_TOKEN',
    PARTNER_ID: 'PARNTER_ID',
    AUTHENTICATION_USER_LOGOUT: 'AUTHENTICATION_USER_LOGOUT',
}

export default constants